import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AlertMessage from "../../common/actions/AlertMessage";
import Loader from "../../common/loaders/Loader";
import PageTitle from "../../common/shared/PageTitle";
import formatNumber from "../../utils/formatNumber";
import ConferenceIcon from "../../common/icons/ConferenceIcon";
import DownloadButton from "../../common/buttons/DownloadButton";
import saveDownload from "../../utils/downloadFile";
import BackButton from "../../common/buttons/BackButton";
import {
  Card,
  CardBody,
  Input,
  Option,
  Select,
} from "@material-tailwind/react";
import { DataGrid } from "@mui/x-data-grid";

import {
  conferenceCrecheAction,
  conferenceMiscFilterAction,
} from "../../redux/actions/conference/conference_action";
import DataTable from "../../common/shared/DataTable";
import { type } from "@testing-library/user-event/dist/type";
import FilterButton from "../../common/buttons/FilterButton";
import ClearFilterButton from "../../common/buttons/ClearFilterButton";
import Modal from "../../common/actions/Modal";

const filterItem = [
  { name: "Bar Number", value: "bar_number" },
  { name: "Name", value: "name" },
];

function ConferenceCreche() {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);

  const [filteredResult, setFilteredResult] = useState([]);
  const [totalData, setTotalData] = useState([]);

  const [filterModal, setFilterModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const [filterText, setFilterText] = useState("");
  const [selectedColumn, setSelectedColumn] = useState(
    filterItem[0]?.value || ""
  );

  const dispatch = useDispatch();

  const { data, conferenceError, search } = useSelector(
    (state) => state.conference
  );

  const handleSearch = (e) => {
    e.preventDefault();

    setSearchLoading(true);

    const data = {
      [selectedColumn]: filterText,
      type: "creche",
      id,
    };

    dispatch(conferenceMiscFilterAction(data)).finally(() => {
      setSearchLoading(false);
      setShowFilter(true);
      setFilterModal(false);
    });
  };

  const handleClearFilter = () => {
    setShowFilter(false);
    setFilteredResult([]);
  };

  const handleColumnChange = (event) => {
    setSelectedColumn(event);
  };

  const handleFilterTextChange = (e) => {
    setFilterText(e.target.value);
  };

  const columns = [
    // {
    //   field: "arrayIndex",
    //   headerName: "ID",
    //   width: 80,
    //   valueFormatter: (params) => (params.value + 1).toString(),
    // },
    {
      field: "full_name",
      headerName: "Name",
      flex: 1,
      valueGetter: (params) =>
        params?.row?.full_name + " - " + params?.row?.bar_number,
    },
    {
      field: "chamber",
      headerName: "Chamber",
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="flex flex-col">
            {params?.row?.chamber.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: (params) => {
        const statusValue = params.row.status;
        return (
          <span
            className={`inline-flex items-center rounded-md ${
              statusValue === "Paid"
                ? "bg-green-50 text-green-700 ring-green-600/20"
                : "bg-orange-50 text-orange-700 ring-orange-600/20"
            } px-2 py-1 text-xs font-medium ring-1 ring-inset`}
          >
            {statusValue}
          </span>
        );
      },
    },
    {
      field: "phone",
      headerName: "Phone #",
      width: 100,
      renderCell: (params) => {
        <div className="text-wrap my-2">
          <span>{params?.row?.phone}</span>;
        </div>;
      },
    },
    {
      field: "email",
      headerName: "Email Address",
      width: 200,
      renderCell: (params) => {
        <div className="text-wrap my-2">
          <span>{params?.row?.email}</span>;
        </div>;
      },
    },
  ];

  useEffect(() => {
    dispatch(conferenceCrecheAction(id)).finally(() => setLoading(false));
  }, [dispatch, id]);

  useEffect(() => {
    if (search) setFilteredResult(search);
    if (data) setTotalData(data);
  }, [data, search]);

  return (
    <>
      {conferenceError && (
        <AlertMessage status="error" message={conferenceError} />
      )}

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex justify-between p-4">
            <div className="flex items-center">
              <PageTitle
                title="Conference Creche Facilities"
                subheading={formatNumber(data.length)}
                icon={<ConferenceIcon />}
              />
            </div>

            <div className="flex items-center gap-4">
              <DownloadButton
                onClick={() => saveDownload(data, "Conference Facilities")}
              />
              <FilterButton onClick={() => setFilterModal(true)} />
              {showFilter && (
                <ClearFilterButton onClick={() => setShowFilter(false)} />
              )}
            </div>
          </div>

          <BackButton />

          <DataTable
            rows={showFilter ? filteredResult : totalData}
            columns={columns}
          />

          {filterModal && (
            <Modal
              title="Filter Data"
              size="sm"
              open={true}
              content={
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                  <div className="relative w-full max-w-xs">
                    <Select
                      onChange={handleColumnChange}
                      value={selectedColumn}
                      label="Select Column"
                    >
                      {filterItem.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div className="relative w-full max-w-xs">
                    <Input
                      label="Type here"
                      className="input input-bordered w-full"
                      value={filterText}
                      onChange={handleFilterTextChange}
                    />
                  </div>
                </div>
              }
              actionLabel="Filter"
              closeLabel="Close"
              onAction={(e) => handleSearch(e)}
              onClose={() => setFilterModal(false)}
            />
          )}

          {/* <Card className="w-full p-6 shadow-xl mb-20">
            <CardBody>
              <DataGrid
                sx={{ border: 0 }}
                initialState={{ density: "comfortable" }}
                rows={data.map((row, index) => {
                  return {
                    ...row,
                    arrayIndex: index,
                  };
                })}
                columns={columns}
                getRowHeight={() => "auto"}
              />
            </CardBody>
          </Card> */}
        </>
      )}
    </>
  );
}

export default ConferenceCreche;
